import React, { FC } from "react"
import { Grid } from "@material-ui/core"

import { sanitizeIncorrectKey } from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/utils/snoozeTime"

import { ActionDialog } from "@/components"

import SnoozeTimeSelector from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/SnoozeTimeSelector"
import SnoozePreview from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/SnoozePreview"
import SnoozeNoteField from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/SnoozeNoteField"

import { SnoozeType } from "@/services/Snooze"

import useSnoozeState from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/hooks/useSnoozeState"
import useSnooze from "@/hooks/useSnooze"

import { BuildedMessage } from "@/protocols/messages"
import HardCoded from "@/services/HardCoded"

export type BaseSnoozeDialogProps = {
	inboxChannelChatId: number
	isOpenDialog: boolean
	onClose: () => void
	messages?: BuildedMessage[]
	wabaTemplateMessageId?: number
	snoozeType: SnoozeType
	isSaveButtonDisabled?: boolean
	userId: number
	instanceId: number
}

const BaseSnoozeDialog: FC<BaseSnoozeDialogProps> = (props) => {
	const {
		children,
		inboxChannelChatId,
		isOpenDialog,
		onClose,
		wabaTemplateMessageId,
		messages,
		snoozeType,
		isSaveButtonDisabled,
		userId,
		instanceId
	} = props

	const {
		handleChangeSnoozeNote,
		snoozeData,
		handleFullTimeChange,
		handleTimeTypeChange,
		handleTimeChange,
		handleSetSnoozeTime
	} = useSnoozeState({ userId, instanceId, inboxChannelChatId })

	const {
		handleCreateSnooze
	} = useSnooze({ inboxChannelChatId })

	const handleCloseSnoozeDialog = () => {
		onClose()
	}

	const handleSave = async () => {
		await handleCreateSnooze({
			snoozeData,
			onUpdateSnoozeTime: handleSetSnoozeTime,
			...(messages && {
				content: {
					messages
				}
			}),
			...(wabaTemplateMessageId && {

				wabaTemplateMessage: {
					id: wabaTemplateMessageId
				}
			}),
			snoozeType
		})

		handleCloseSnoozeDialog()

		if (wabaTemplateMessageId && HardCoded.checkFeatureFlag("canUseWABATemplateCreditsLimit")) {
			ActionDialog.open({
				openDialog: true,
				title: "ATENÇÃO",
				children: "Certifique-se de ter créditos de mensagem suficientes no momento do envio para garantir que o template seja enviado com sucesso.",
				saveText: "Estou ciente",
				hideCloseButton: true,
				forcedRender: true,
				onSave: handleCloseSnoozeDialog
			})
		}
	}

	return (
		<ActionDialog
			onClose={handleCloseSnoozeDialog}
			onSave={handleSave}
			openDialog={isOpenDialog}
			title="Novo soneca"
			saveText="DEFINIR SONECA"
			saveButtonDisabled={isSaveButtonDisabled}
			maxWidth="sm"
		>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<SnoozeTimeSelector
							onTimeChange={handleTimeChange}
							onKeyDown={sanitizeIncorrectKey}
							onTimeTypeChange={handleTimeTypeChange}
							snoozeData={snoozeData}
						/>
						<SnoozePreview
							fullTime={snoozeData?.snoozeTime?.fullTime || new Date()}
							onFullTimeChange={(date) => handleFullTimeChange(date || new Date())}
						/>
						<SnoozeNoteField
							onChange={handleChangeSnoozeNote}
							value={snoozeData.snoozeNote}
						/>
					</Grid>
				</Grid>

				{children && (
					<Grid item xs={12}>
						{children}
					</Grid>
				)}
			</Grid>
		</ActionDialog>
	)
}

export default BaseSnoozeDialog
